<script lang="ts">
	import { _ } from "svelte-i18n";
	import { FormGroup, Input, Label } from "@sveltestrap/sveltestrap";
	import { SLIDE_COUNT_STOPS, type SlideCountStop } from "./slideCountStops.ts";

	const STOPS = SLIDE_COUNT_STOPS;
	type Stop = SlideCountStop;

	let { value = $bindable() }: { value: number } = $props();

	const index = $derived(Math.max(0, STOPS.indexOf(value as Stop)));

	function onInput(event: Event) {
		const i = Number((event.target as HTMLInputElement).value);
		value = STOPS[i];
	}
</script>

<FormGroup>
	<Label for="v2-slide-count">
		{$_("landingpage.newPresentation.numberOfSlides")}:
		<strong>{value}</strong>
	</Label>
	<div class="slider">
		<Input
			type="range"
			id="v2-slide-count"
			min={0}
			max={STOPS.length - 1}
			step={1}
			value={index}
			on:input={onInput}
		/>
		<div class="ticks" aria-hidden="true">
			{#each STOPS as stop, i}
				<span class="tick" style="left: {(i / (STOPS.length - 1)) * 100}%">
					<span class="tick-mark"></span>
					<span class="tick-label">{stop}</span>
				</span>
			{/each}
		</div>
	</div>
</FormGroup>

<style>
	.slider {
		position: relative;
	}
	/*
	 * Bootstrap's .form-range has a 1rem-wide thumb; its center sits 0.5rem
	 * inside the track at min and max. Inset the tick container by that same
	 * 0.5rem on both sides so tick `left: 0%` aligns with the thumb-center
	 * at min and `left: 100%` with the thumb-center at max.
	 */
	.ticks {
		position: relative;
		height: 1.5rem;
		margin: -0.25rem 0.5rem 0;
	}
	.tick {
		position: absolute;
		transform: translateX(-50%);
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 0.875rem;
		color: var(--bs-secondary-color, #6c757d);
	}
	.tick-mark {
		width: 1px;
		height: 0.5rem;
		background: currentColor;
	}
	.tick-label {
		margin-top: 0.125rem;
		line-height: 1;
	}
</style>
